import administrationReducers from "./administrationReducers";
import grhReducers from "./grhReducers";
import onboardingReducers from "./onboardingReducers";
import formationReducers from "./formationReducers";
import skillsReducers from "./skillsReducers";
import kmsReducers from "./kmsReducers";
import recrutementReducers from "./recrutementReducers";
import performanceReducers from "./performanceReducers";

const moduleReducers = {
  ...administrationReducers,
  ...grhReducers,
  ...onboardingReducers,
  ...formationReducers,
  ...skillsReducers,
  ...kmsReducers,
  ...recrutementReducers,
  ...performanceReducers,
};

export default moduleReducers;
